<script>
import { mapState, mapActions } from 'vuex';
// import CustomComponent from '@/components/CustomComponent';
import { getAsset } from '@/scripts/utils';
import { countablePostfix } from '@/scripts/utils/time';
import { get as getKey } from 'lodash';
import { humanizeDate } from '@/scripts/utils/time';

export default {
  name: 'DashboardCard',
  components: {},
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    stats: {
      type: Object,
    },
    activeTimeFilter: {},
  },
  data() {
    return {
      visibleInfo: false,
    };
  },
  computed: {
    ...mapState([]),
    since() {
      const { stats } = this;

      if (!stats) return null;

      const { connected } = stats;

      const result = humanizeDate(connected);

      return result;
    },
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions({}),
    getIcon(name) {
      const result = getAsset(name, {
        strict: true,
        path: 'dashboard-cards',
        style: true,
      });

      return result;
    },
    getTitle(item) {
      const { since } = this;
      const { statsField, caption } = item;
      const addSince = statsField === '_earnings' && since;

      const result = addSince ? `${caption} (${since})` : caption;

      return result;
    },
    getValue(item = {}) {
      const { statsField } = item;
      const { stats, activeTimeFilter } = this;
      const path = `${activeTimeFilter}.${statsField}`;
      const value = getKey(stats, path);
      const result = value;

      return result;
    },
    countablePostfix,
  },
};
</script>

<template>
  <div
    :class="['card', 'card--' + item.type, 'card--columns-' + item.columns]"
    :style="getIcon(item.type)"
  >
    <div class="card__title-wrapper">
      <div class="card__title">
        {{ getTitle(item) }}
      </div>
      <div class="card__tooltip" v-if="item.statsField === '_earnings'">
        <div class="card__tooltip-title">Stats are not real-time</div>
        <div :class="{ tooltip: true, active: visibleInfo }">
          <div class="tooltip__icon" @click="visibleInfo = !visibleInfo">
            <img :src="require(`@/assets/svg/info.svg`)" />
          </div>
          <div class="tooltip__content-wrapper">
            <div class="tooltip__content">
              There may be a delay in your stats and rewards displaying. If your
              stats do not display correctly please check back later and
              refresh. Thank You
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card__value-wrapper">
      <div class="card__value">
        {{ getValue(item) }}
      </div>
      <span
        v-if="stats && item.units"
        :class="{ 'ml-5': item.whitespaceBeforeUnits }"
        >{{
          item.type === 'rank' ? countablePostfix(getValue(item)) : item.units
        }}</span
      >
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.card {
  background-color: #232e33;
  border-radius: 24px;
  height: 130px;
  width: 200px;
  padding: 15px;
  margin: 15px 0 0 15px;
  position: relative;
  background-position: right bottom;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &__title {
    font-family: Poppins-Regular;
    font-size: 14px;
    line-height: 20px;
    position: relative;
    color: #00b8f9;
    display: flex;
    align-items: center;

    span {
      margin-left: 3px;
    }
  }

  &__value {
    font-family: Poppins-Light;
    font-size: 36px;
    letter-spacing: 1.33px;
  }

  &__value-wrapper {
    margin-top: 10px;
    color: #ffffff;
    display: flex;
    align-items: flex-end;
    line-height: 51px;

    span {
      font-size: 16px;
      line-height: 39px;
      font-family: Poppins-Light;

      &.ml-5 {
        margin-left: 5px;
      }
    }
  }

  &__tooltip {
    flex-grow: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-shrink: 0;
  }

  &__tooltip-title {
    display: flex;
    align-items: center;
    font-family: Poppins-Regular;
    font-size: 12px;
    line-height: 17px;
    color: #ffc107;
    margin-right: 5px;
  }

  &__title-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
  }

  &--columns-2 {
    width: 415px;
  }

  &--leaderboard-rank {
    .card__value {
      color: #ffc107;
      letter-spacing: 0.75px;
    }
  }

  &--rank {
    .card__value-wrapper {
      color: #ffc107;

      .card__value {
        letter-spacing: 0.75px;
      }

      span {
        font-size: 36px;
        line-height: 51px;
      }
    }
  }

  &--earnings,
  &--ratio {
    .card__value {
      letter-spacing: normal;
    }
  }

  &--top,
  &--win-rate {
    .card__title {
      color: #ffc800;
    }
  }
}

.tooltip {
  position: relative;

  &.active {
    .tooltip__content-wrapper {
      display: block;
    }
  }

  &__title {
    display: flex;
    align-items: center;
    font-family: Poppins-Regular;
    font-size: 12px;
    line-height: 17px;
    color: #ffc107;
  }

  &__icon {
    cursor: pointer;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    margin-top: 1px;

    img {
      display: flex;
      width: 8px;
      height: 8px;
    }
  }

  &__content-wrapper {
    padding-bottom: 5px;
    position: absolute;
    bottom: 100%;
    right: -4px;
    padding-bottom: 6px;
    display: none;
  }

  &__content {
    width: 235px;
    height: auto;
    border-radius: 12px;
    box-shadow: 0 20px 40px 0 rgba(8, 7, 16, 0.5);
    background-color: #1d2429;
    font-family: Poppins-Regular;
    font-size: 12px;
    color: #ffffff;
    padding: 10px 10px 18px;
    line-height: 1.4;
  }
}

@media (min-width: $mobile) {
  .tooltip {
    &:hover {
      .tooltip__content-wrapper {
        display: block;
      }
    }
  }
}

@media (max-width: $mobile) {
  .card {
    flex-grow: 1;
    width: auto;
    min-width: 140px;
    min-height: 90px;
    height: auto;
    margin: 10px 0 0 10px;
    border-radius: 16px;
    background-size: 40px 40px;

    &--columns-2 {
      width: 100%;
    }

    &__title {
      font-size: 12px;
      line-height: 17px;
    }

    &__tooltip-title {
      display: none;
    }

    &__value {
      font-size: 24px;
      line-height: 33px;
      letter-spacing: 0.89px;
    }

    &__value-wrapper {
      span {
        line-height: 27px;
      }
    }

    &--leaderboard-rank {
      .card__value {
        color: #ffc107;
        letter-spacing: 0.5px;
      }
    }

    &--rank {
      .card__value {
        letter-spacing: 0.5px;
      }

      .card__value-wrapper {
        span {
          line-height: 33px;
          font-size: 24px;
        }
      }
    }
  }

  .tooltip {
    &__icon {
      img {
        width: 16px;
        height: 16px;
      }
    }
  }
}
</style>
